import { inject } from '@angular/core';
import {
  setError,
  setLoaded,
  setLoading,
  withResourceState,
} from '@kinet-open-network/client/shared/data-access/state';
import { patchState, signalStore, withMethods } from '@ngrx/signals';
import { ClosuresService } from '../services/closures.service';

export const ClosuresStore = signalStore(
  { protectedState: false },
  withResourceState(ClosuresService),
  withMethods((store, service = inject(ClosuresService)) => ({
    recompute: async (id: string) => {
      patchState(store, setLoading());
      try {
        const closure = await service.recompute(id);
        store.patchModel(closure);
        patchState(store, setLoaded());
        return closure;
      } catch (error) {
        patchState(store, setError(error));
        throw error;
      }
    },
    exportItems: async (id: string, grouped = true) => {
      patchState(store, setLoading());
      try {
        await service.exportItems(id, grouped);
        patchState(store, setLoaded());
      } catch (error) {
        patchState(store, setError(error));
        throw error;
      }
    },
  })),
);
